import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { getText, trackGA } from 'misc/helpers';
import * as types from 'misc/types';

class End extends Component {
    render = () => {
        return (
            <div className="main-content">
                <div className="complement-content">
                    <img className="complement-logo" src="assets/images/verify/ico_dm_v.svg" alt="" />
                    <React.Fragment>
                        <h1>{getText('_12_4_Titel_EndDigimail', 'Vad tråkigt att du vill lämna oss')}</h1>
                        <p>
                            {getText(
                                '_12_4_text_EndDigimail',
                                'Du har nu valt att avsluta din Digimail. Detta kommer leda till att du från och med nu inte kommer få några nya brev till din brevlåda. Du har däremot 90 dagar på dig att aktivera din digitala brevlåda igen, om du har ångrat dig eller vill hämta ut dina sparade brev. För att göra detta logga du in igen med ditt bankID. Glöm inte att du måste godkänna de allmänna villkoren om detta inte gjorts.\nOm du inte väljer att logga in kommer din brevlåda att raderas efter 90 dagar. '
                            )}
                        </p>

                        <button className="button-yellow button-big button-bankid" onClick={() => this.endAccount()}>
                            {getText('_12_4_text_button_EndDigimail', 'Avsluta Digimail')}
                        </button>
                        <Link className="deny-link" to={"/"+this.props.match.params.referer}>
                            {getText('_6_4_button_ending_Digimail_back', 'Tillbaka')}
                        </Link>
                    </React.Fragment>
                </div>
                <img className="logo-bottom-left" src="assets/images/digimail_logo_yellow.svg" alt="" />
            </div>
        );
    };

    endAccount() {
        const { sessions, dispatch } = this.props;

        dispatch({ 
            type: types.SAGA_CUSTOMER_DELETE.REQUEST,
            personnr: sessions.data.customerId 
        });
    }

    componentDidMount() {
        trackGA('6.4 Avsluta');
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        sessions: state.sessions,
        customer: state.customer
    };
};

export default connect(mapStateToProps)(End);



// WEBPACK FOOTER //
// ./src/components/views/End.js